import { render, staticRenderFns } from "./ActionDownloadEvidence.vue?vue&type=template&id=1f983418"
import script from "./ActionDownloadEvidence.vue?vue&type=script&lang=js"
export * from "./ActionDownloadEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports